import { useQuery } from '@tanstack/react-query';
import { getUserOwnTractorPokesMeCount } from '../../../../api/user/queries/getUserOwnTractorPokesMeCount';
import { AxiosError } from 'axios';
import { useCheckUserLoggedIn } from '../../../user/useCheckUserLoggedIn';

export const useGetUserOwnTractorPokesMeCount = () => {
  const { isUserLoggedIn } = useCheckUserLoggedIn();

  return useQuery<number, AxiosError>(['user_own_tractor_pokes_me_count'], getUserOwnTractorPokesMeCount, {
    enabled: isUserLoggedIn,
  });
};
